(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/confirm-phone-dialog/assets/javascripts/confirm-phone-dialog.js') >= 0) return;  svs.modules.push('/components/accountservices/confirm-phone-dialog/assets/javascripts/confirm-phone-dialog.js');
'use strict';

svs.accountservices = svs.accountservices || {};
const logger = svs.core.log.getLogger('accountservices:confirm_phone_dialog');
const clearUrlParams = () => {
  svs.utils.url.refreshQueryString();
  const {
    guid: currentGuid,
    customer_id: currentCustomerId
  } = svs.utils.url.queryString;
  if (currentGuid || currentCustomerId) {
    let delim = '?';
    let targetString = '';
    for (const param in svs.utils.url.queryString) {
      if (param !== 'guid' && param !== 'customer_id') {
        targetString = "".concat(targetString).concat(delim).concat(param, "=").concat(encodeURIComponent(svs.utils.url.queryString[param]));
        delim = '&';
      }
    }
    window.history.replaceState({}, '', "".concat(window.location.pathname).concat(targetString));
    svs.utils.url.refreshQueryString();
  }
};
svs.accountservices.confirm_phone_dialog = (() => {
  const guid = svs.utils.url.queryString.guid;
  const customerId = svs.utils.url.queryString.customer_id;
  if (guid && customerId) {
    clearUrlParams();
    svs.core.jupiter.call({
      method: 'POST',
      path: '/player/1/mobile/confirmationlink',
      data: {
        guid,
        customerId
      }
    }, res => {
      const showDialog = res && res.mobileConfirmationLinkReply && res.mobileConfirmationLinkReply.mobile;
      if (showDialog) {
        const successDialog = new svs.ui.dialog.Confirm({
          actions: [{
            title: 'Ok'
          }],
          area: svs.ui.dialog.area.POPUP,
          branding: svs.ui.dialog.branding.SPORT,
          icon: 'checkmark',
          message: [{
            text: 'Vill du även ange din e-post? Logga in och ändra dina kommunikationsval.'
          }],
          title: 'Tack, ditt mobilnummer är nu bekräftat.'
        });
        svs.ui.dialog.api.add(successDialog);
      }
    }, err => {
      const errorDialog = new svs.ui.dialog.Confirm({
        actions: [{
          title: 'Ok'
        }],
        area: svs.ui.dialog.area.POPUP,
        branding: svs.ui.dialog.branding.SPORT,
        icon: 'help-2',
        message: [{
          text: 'Logga in och kontrollera dina kontaktuppgifter, eller kontakta kundservice för mer information.'
        }],
        title: 'Ditt mobilnummer kunde inte verifieras.'
      });
      svs.ui.dialog.api.add(errorDialog);
      logger.error('Error from /player/1/mobile/confirmationlink', err);
    });
  }
})();

 })(window);